import { useState } from "react";
import { TextField } from "@mui/material";
import { FormDialog } from "../popup";

const AddMaterialModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({ name: "", category: "", rate: "" });
  const change = (name) => (event) => setFormData((current) => ({ ...current, [name]: event.target.value }));
  return <FormDialog open onClose={onClose} title="Add material" subtitle="Create an inventory material" onSubmit={(event) => { event.preventDefault(); onSubmit(formData); }} submitLabel="Create">
    <TextField required label="Name" value={formData.name} onChange={change("name")} fullWidth autoFocus />
    <TextField label="Category" value={formData.category} onChange={change("category")} fullWidth />
    <TextField label="Rate" type="number" value={formData.rate} onChange={change("rate")} fullWidth />
  </FormDialog>;
};

export default AddMaterialModal;
